import AsyncStatus from 'mini-common-schema/lib/schema/AsyncStatus';
import { createStore } from 'satcheljs';
import { MailSearchStore } from './schema/MailSearchStore';
import { SearchSourcePreference } from 'mini-search-common/lib/schema/SearchSourcePreference';
import { SubstrateInstrumentationContext } from 'mini-search-common/lib/schema/SubstrateInstrumentationContext';

const initialMailSearchResultsStore: MailSearchStore = {
    searchSource: SearchSourcePreference.None,
    lastSelectedMailFolderId: null,
    currentFolderScopeId: null,
    searchNumber: 0,
    searchResultsItemIdToReferenceIdMap: new Map<string, SubstrateInstrumentationContext>(),
    asyncStatus: AsyncStatus.Idle,
};

const store = createStore<MailSearchStore>('3SMailSearchStore', initialMailSearchResultsStore)();

export const getMailSearchStore = () => store;
